import { useState, useEffect } from 'react';
import brokerConfig, { appVersionConfigUrl } from '../config/brokerConfig';


/**
 * useApkLink
 *
 * Returns the Android APK download link for the current broker.
 * - Starts with the hardcoded brokerConfig.apkLink so the UI renders immediately.
 * - Fetches the broker's app_version_config JSON from S3 and switches to its
 *   platform.android.apk_url when present.
 * - Keeps the hardcoded link on any error (network, CORS, timeout, empty apk_url).
 */
function useApkLink() {
  const [apkLink, setApkLink] = useState();

  useEffect(() => {
    if (!appVersionConfigUrl) return;

    let cancelled = false;
    const fetchApkLink = async () => {
      try {
        const response = await fetch(appVersionConfigUrl);
        if (!response.ok) return null;
        const data = await response.json();
        return data?.platform?.android?.apk_url || null;
      } catch (err) {
        return null;
      }
    };

    fetchApkLink().then((remoteLink) => {
      if (!cancelled && remoteLink) setApkLink(remoteLink);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return apkLink;
}

export default useApkLink;
